export default __webpack_public_path__ + "static/media/bg-03.0bae9702.png";